var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPixFilled = function SvgHtlPixFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.365 11.178a1.753 1.753 0 0 1-1.247-.515l-1.8-1.8a.342.342 0 0 0-.473 0l-1.809 1.805a1.754 1.754 0 0 1-1.247.516h-.353l2.283 2.283a1.826 1.826 0 0 0 2.58 0l2.287-2.288-.221-.001ZM4.789 4.815a1.753 1.753 0 0 1 1.247.516l1.807 1.808a.335.335 0 0 0 .473 0l1.8-1.8a1.749 1.749 0 0 1 1.247-.517h.217L9.293 2.535a1.824 1.824 0 0 0-2.58 0l-2.277 2.28h.353Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.474 6.712 12.092 5.33a.267.267 0 0 1-.1.02h-.626c-.327.001-.64.13-.872.361l-1.8 1.8a.865.865 0 0 1-1.222 0l-1.81-1.809a1.24 1.24 0 0 0-.872-.362h-.772a.27.27 0 0 1-.093-.019l-1.39 1.391a1.826 1.826 0 0 0 0 2.58l1.389 1.386a.26.26 0 0 1 .093-.019h.775c.327 0 .64-.13.872-.362L7.471 8.49a.886.886 0 0 1 1.223 0l1.8 1.8c.232.23.545.36.872.361h.628a.26.26 0 0 1 .1.02l1.382-1.382a1.825 1.825 0 0 0 0-2.58"
  })));
};
export default SvgHtlPixFilled;